import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import withStyles from '@mui/styles/withStyles';
import Grid from '@mui/material/Grid';
import MuiButton from '@mui/material/Button';
import LoginIcon from '@mui/icons-material/ExitToApp';
import DeleteIcon from '@mui/icons-material/Delete';

// core components
import Card from '../md/components/Card/Card.jsx';
import CardHeader from '../md/components/Card/CardHeader.jsx';
import CardBody from '../md/components/Card/CardBody.jsx';

import accountOverviewStyle from '../assets/jss/crm/views/accountOverviewStyle';

import { pushLogin } from '../store/slices/loginsSlice';
import { clearFirmInfo } from '../store/slices/firmInfoSlice';
import { setUserInfo } from '../store/slices/userInfoSlice';
import { setApiResponseInfo } from '../store/slices/apiResponseInfoSlice';
import { updateAccount } from '../store/slices/accountsSlice';

import { createStdRequest, apiFetch } from '../utils/utils';

import ReduxLoader from '../store/ReduxLoader';

import KSpinner from '../components/KSpinner';

/*
const fancyStyle = {
  gradient: {
    background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
    borderRadius: 3,
    border: 0,
    color: 'white',
    height: 26,
    padding: '0 6px',
    boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
  }}
  */

class AccountOverview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dataIsReady: false,
      errorMessage: '',
      redirect: undefined,
      toHome: false,
      toAccountsListPage: false,
    };
  }

  componentDidMount() {
    /*
    const firmId = this.props.idOfAccountToShow;
    if (ReduxLoader.alreadyLoadedFirm(firmId)) {
      this.setState({ dataIsReady: true });
      return;
    }
    ReduxLoader.loadFirmInfo(firmId, this, () => this.setState({ dataIsReady: true }));
    */
    this.fillInDataForAccount();
  }

  fillInDataForAccount() {
    this.setState({ loading: true, dataIsReady: false });
    const accountId = this.props.idOfAccountToShow;
    const uri = `/api/demo/provider/${accountId}`; // this is a FirmId, not a ProviderId, alas
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (json) => {
      this.props.updateAccount(json);
      this.setState({ loading: false, dataIsReady: true });
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  deleteAccount = (accountId) => {
    const uri = '/api/demo/provider/' + accountId;
    const request = createStdRequest(uri, 'DELETE');
    const actionOnGoodResponse = (json) => {
      this.props.clearFirmInfo();
      this.setState({ toAccountsListPage: true });
    };
    apiFetch(this, request, actionOnGoodResponse);
  };

  logInToAccount(email) {
    console.log('Should now be logging in to account');
    // Call /api/account/logInToFirm?email=XYZ
    // put the response's new user info into Redux state
    // redirect to Home

    const uri = '/api/account/logInToFirm?email=' + encodeURIComponent(email);
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (json) => {
      const { success, userId, personId, email, phone, role, prefName, lastName, firmId, errorCode } = json;
      if (success) {
        this.setState({ loading: true });
        const loginObj = { loginType: 'toFirm', email };
        this.props.pushLogin(loginObj);
        const userInfo = { userId, personId, email, phone, role, prefName, lastName };
        this.props.setUserInfo(userInfo);
        ReduxLoader.loadFirmInfo(firmId, this, () => this.setStateToGoToNewUserHome());
      } else {
        // Possible problems, by error code:
        //   1) No such user name (email)
        //   2) Good user name, but not attached to a account
        //   3) The associated account is not part of an account
        //   5) Firm has been deactivated
        switch (errorCode) {
          case 1:
            this.setState({ errorMessage: 'We have no account with that user name (email)' });
            break;
          case 2:
            this.setState({ errorMessage: 'The user is not associated with an account' });
            break;
          case 3:
            this.setState({ errorMessage: "There is no account associated with this user's account" });
            break;
          case 5:
            this.setState({ errorMessage: 'The Account has been deactivated' });
            break;
          default:
            this.setState({ errorMessage: 'Unknown login error. Error code: ' + errorCode });
            break;
        }
      }
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  setStateToGoToNewUserHome() {
    this.setState({ loading: false, toHome: true });
  }

  render() {
    if (this.state.toHome) {
      return <Redirect to="/homeDispatcher" />;
    }

    if (this.state.toAccountsListPage) {
      return <Redirect to="accounts" />;
    }

    if (!this.state.dataIsReady) {
      return <KSpinner />;
    }

    if (this.state.loading) {
      return <KSpinner />;
    }

    if (this.state.errorMessage) {
      alert(this.state.errorMessage);
      this.setState({ errorMessage: '' });
    }

    const { idOfAccountToShow, accounts } = this.props;
    if (!idOfAccountToShow || idOfAccountToShow < 1) {
      return (
        <div>
          <h2>No account selected to show.</h2>
          <div>ID of account to show: {idOfAccountToShow}</div>
        </div>
      );
    }

    const matches = accounts.filter((p) => p.firmId === idOfAccountToShow);
    if (matches.length !== 1) {
      if (matches.length === 0) {
        return (
          <div>
            <h2>No firm matches the specified ID.</h2>
            <div>ID of account to show: {idOfAccountToShow}</div>
          </div>
        );
      } else {
        return (
          <div>
            <h2>Too many firms match the specified ID.</h2>
            <div>ID of account to show: {idOfAccountToShow}</div>
          </div>
        );
      }
    }

    const match = matches[0];
    const { providerId, firmName, adminsNamesAndEmails, usersNamesAndEmails } = match;
    const { classes } = this.props;
    return (
      <div>
        <Grid container>
          <Grid item xs={1} />
          <Grid item xs={10}>
            <Card>
              <CardHeader color="allevaOrange" stats icon>
                <h3 className={classes.cardTitle}>Account Overview</h3>
              </CardHeader>
              <CardBody>
                <h4>Account: {firmName}</h4>
                <div>
                  From this page, you can
                  <ul>
                    <li>log in as an Admin of this account</li>
                    <li>log in as one of the regular Users of this account</li>
                    <li>delete the account</li>
                  </ul>
                </div>
                <hr />
                <div>
                  <strong>Admins:</strong>
                  {adminsNamesAndEmails.map((admin) => (
                    <UserLine
                      key={admin.email}
                      name={admin.name}
                      email={admin.email}
                      logInFunc={() => this.logInToAccount(admin.email)}
                    />
                  ))}
                </div>
                <div>
                  <br />
                  <strong>Users:</strong>
                  {usersNamesAndEmails.map((user) => (
                    <UserLine
                      key={user.email}
                      name={user.name}
                      email={user.email}
                      logInFunc={() => this.logInToAccount(user.email)}
                    />
                  ))}
                </div>
                <div>
                  <br />
                  You can {'  '}
                  <MuiButton
                    className={this.props.classes.gradient}
                    size="small"
                    onClick={() => this.deleteAccount(providerId)}
                  >
                    <DeleteIcon />
                    Delete this account now!
                  </MuiButton>
                </div>
              </CardBody>
            </Card>
          </Grid>
        </Grid>
      </div>
    );
  }
}

class UserLine extends Component {
  render() {
    const { name, email, logInFunc } = this.props;
    return (
      <div>
        {name}
        {'  '}
        {email && (
          <MuiButton size="small" onClick={() => logInFunc()}>
            <LoginIcon />
            Log In
          </MuiButton>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  idOfAccountToShow: state.intendedInfo.intendedAccountId,
  accounts: state.accounts.accounts,
});

const actionProducers = { setUserInfo, clearFirmInfo, pushLogin, setApiResponseInfo, updateAccount };

// export default connect(mapStateToProps, actionProducers) (withStyles(fancyStyle)(AccountOverview));
export default connect(mapStateToProps, actionProducers)(withStyles(accountOverviewStyle)(AccountOverview));
